// Última modificación: 27/10/2025

/**
 * Order to sort. ASC or DESC
 * @default "DESC"
 */
export enum DatasetFilterDtoV2SortEnum {
	ASC = "ASC",
	DESC = "DESC",
}
